<template>
    <b-modal id="petientWriteModal" :title="title" size="lg" @hidden="fn_modal_hide">
        <div class="search">
            <div class="table_list">
                <div class="modal_table user">
                    <table class="write">
                        <colgroup>
                            <col width="100">
                            <col width="200">
                            <col width="100">
                            <col width="200">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th><span class="emp">이름</span></th>
                                <td><input type="text" class="form_control" v-model="petientInfo.patient_nm" placeholder="입력하세요"></td>
                                <th>차트번호</th>
                                <td><input type="text" class="form_control" v-model="petientInfo.patient_chart_no" placeholder="입력하세요"></td>                                
                            </tr>
                            <tr>
                              <th><span class="emp">성별</span></th>
                                <td>
                                    <div class="form_select">
                                        <b-form-select v-model="petientInfo.patient_gender_cd">
                                            <b-form-select-option :value="null">선택</b-form-select-option>
                                            <b-form-select-option value="M">남성</b-form-select-option>
                                            <b-form-select-option value="F">여성</b-form-select-option>
                                        </b-form-select>
                                    </div>
                                </td>
                                <th>환자 비고</th>
                                <td><input type="text" class="form_control" v-model="petientInfo.patient_note" placeholder="입력하세요"></td>
                            </tr>
                            <tr>
                              <th><span class="emp">생년월일</span></th>
                                <td colspan="3">
                                    <div class="form_inline">
                                        <div class="form_select">
                                            <b-form-select  v-model="petientInfo.patient_birth_year">
                                                <b-form-select-option v-for="(yyyy, index) in yearList" :key="index" :value="yyyy">{{yyyy}}년</b-form-select-option>
                                            </b-form-select>
                                        </div>
                                        <div class="form_select">
                                            <b-form-select v-model="petientInfo.patient_birth_month">
                                                <b-form-select-option v-for="(mm, index) in monthList" :key="index" :value="mm">{{mm}}월</b-form-select-option>
                                            </b-form-select>
                                        </div>
                                        <div class="form_select">
                                            <b-form-select v-model="petientInfo.patient_birth_day">
                                                <b-form-select-option v-for="(dd, index) in dayList" :key="index" :value="dd">{{dd}}일</b-form-select-option>
                                            </b-form-select>
                                        </div>                                    
                                    </div>
                                </td>
                            </tr>                            
                            <tr>
                              <th><span class="emp">전화번호</span></th>
                                <td colspan="3">
                                    <div class="form_inline">
                                        <div class="form_select">
                                            <b-form-select v-model="petientInfo.patient_tel_first">
                                                <b-form-select-option v-for="(telNum, index) in telList" :key="index" :value="telNum">{{telNum}}</b-form-select-option>
                                            </b-form-select>
                                        </div>
                                        -
                                        <div class="form_select">
                                            <input type="text" class="form_control" v-model="petientInfo.patient_tel_mid" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" placeholder="입력하세요">
                                        </div>
                                        -
                                        <div class="form_select">
                                            <input type="text" class="form_control" v-model="petientInfo.patient_tel_last" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" placeholder="입력하세요">
                                        </div>                                    
                                    </div>
                                </td>
                            </tr>                            
                            <tr>
                              <th><span class="emp">우편번호</span></th>
                                <td colspan="3">
                                    <div class="form_inline">
                                    <input type="text" class="form_control limit" v-model="petientInfo.patient_post_no" placeholder="입력해주세요." readonly>
                                    <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('patient')">주소검색</button>
                                    </div>
                                </td>
                            </tr>   
                            <tr>
                              <th><span class="emp">주소</span></th>
                                <td colspan="3"><input type="text" class="form_control" v-model="petientInfo.patient_addr" placeholder="입력하세요" readonly></td>
                            </tr>
                            <tr>
                              <th><span class="emp">상세주소</span></th>
                                <td colspan="3"><input type="text" class="form_control" v-model="petientInfo.patient_addr_dtl" placeholder="입력하세요"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer>
            <b-button class="btn btn_md btn_brown" @click="fn_patient_save()">신규 환자 등록</b-button>
        </template>
        <alert-modal
            :id="'alert'"
            :text="showAlertMsg"
            :btnRight="'확인'"
            :oneBtn="false"
            :isShow="showAlert"
            :className="'btn_brown'"
            :closeEventValue="closeEventValue"
            @closeEvent="oncCloseEvent"
            v-on:update:showSetting="fn_showSet"
        />
    </b-modal>
</template>

<script>
    import commonUtil from "@/mixin/commonUtil";
    import axios from 'axios'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";


    export default {
        name: 'petientWriteModal',
        components: {'alert-modal' : AlertModal},
        mixins: [commonUtil,alertutill],
        props: {
            title: String,
        },
        data () {
            return {
                selected: null,
                petientInfo : {
                    patient_chart_no : '',
                    patient_nm : '',
                    patient_gender_cd : null,
                    patient_age : 0,
                    patient_birth_year : 0,
                    patient_birth_month : 0,
                    patient_birth_day : 0,
                    patient_tel_num : '',
                    patient_tel_first : '010',
                    patient_tel_mid : '',
                    patient_tel_last : '',
                    patient_post_no : '',
                    patient_addr : '',
                    patient_addr_dtl : '',
                    patient_note : ''
                },
                currentYear : 0,
                yearList : [],
                monthList : [],
                dayList : [],
                telList : ['010','011','016','017','018','019']

            }
        },
        created(){
            let now = new Date();	// 현재 날짜 및 시간
            this.currentYear = now.getFullYear();	// 연도

            for(let i = this.currentYear; i > this.currentYear -100; i--){
                this.yearList.push(i);
            }

            for(let i = 1; i < 13; i++){
                this.monthList.push(i);
            }

            for(let i = 1; i < 32; i++){
                this.dayList.push(i);
            }            

            this.petientInfo.patient_birth_year = this.currentYear;
            this.petientInfo.patient_birth_month = 1;
            this.petientInfo.patient_birth_day = 1;   

            this.petientInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId']                        
        },
        methods : {
            //다음주소 정보 가져오기
            callBackAddr(call,postInfo){
                
                this.petientInfo.patient_post_no = postInfo.zonecode;
                this.petientInfo.patient_addr = postInfo.roadAddress;
            },        
            //모달창이 닫힐때 마다 초기화
            fn_modal_hide(){
                this.petientInfo = {
                    patient_chart_no : '',
                    patient_nm : '',
                    patient_gender_cd : null,
                    patient_age : 0,
                    patient_birth_year : 0,
                    patient_birth_month : 0,
                    patient_birth_day : 0,
                    patient_tel_num : '',
                    patient_tel_first : '010',
                    patient_tel_mid : '',
                    patient_tel_last : '',
                    patient_post_no : '',
                    patient_addr : '',
                    patient_addr_dtl : '',
                    patient_note : '',
                    clinic_doctor_id : ''
                };

                this.petientInfo.patient_birth_year = this.currentYear;
                this.petientInfo.patient_birth_month = 1;
                this.petientInfo.patient_birth_day = 1; 
            },
            fn_patient_save(){

                // if(this.chkValidate()){
                //   return;
                // }

                if(this.petientInfo.patient_tel_mid != "" || this.petientInfo.patient_tel_last != ""){
                    this.petientInfo.patient_tel_num = this.petientInfo.patient_tel_first + this.petientInfo.patient_tel_mid + this.petientInfo.patient_tel_last;
                }else{
                    this.petientInfo.patient_tel_num = "";
                }

                
                this.petientInfo.patient_age = this.currentYear - this.petientInfo.patient_birth_year;

                console.log("@@@@@ param : %o",this.petientInfo);

                axios
                    .post("/api/user/petient/setPetientInfo", this.petientInfo)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);

                        this.$emit('callback', res.data.patient_seq);
                        this.$bvModal.hide('petientWriteModal');
                    })
                    .catch((err) => console.log(err));
            },
            // chkValidate(){
            //     if(this.petientInfo.patient_nm == ''){
            //         let msg = "이름을 입력해주세요.";
            //         this.fn_open_alert(msg);
            //         return true;
            //     }
            //
            //   if( this.patientInfo.patient_tel_mid != "" || this.patientInfo.patient_tel_last != ""){
            //     if( this.patientInfo.patient_tel_mid == '' || this.patientInfo.patient_tel_last == ''){
            //       let msg = "연락처를 올바르게 입력해주세요.";
            //       this.fn_open_alert(msg);
            //       return true;
            //     }
            //   }
            //
            //   if(this.patientInfo.patient_post_no == '') {
            //     let msg = "우편번호를 입력해주세요.";
            //     this.fn_open_alert(msg);
            //     return true;
            //   }
            //
            //   if(this.patientInfo.patient_addr == '') {
            //     let msg = "주소를 입력해주세요.";
            //     this.fn_open_alert(msg);
            //     return true;
            //   }
            //
            //   if(this.patientInfo.patient_addr_dtl == '') {
            //     let msg = "상세주소를 입력해주세요.";
            //     this.fn_open_alert(msg);
            //     return true;
            //   }
            //
            // },
            //결제비용 하단 좌표 고정
            resetLeft () {
                if (this.isShow.patient) {
                    return this.leftArea - 540
                } else {
                    return this.leftArea
                }
            }
        }
    }
</script>

<style>

</style>